import { useQuery } from "@apollo/client";
import { useAbility } from "@/partner/shared/lib";
import { UnpaidContractPaymentsQuery } from "../graphql/queries";
import type { UnpaidContractPaymentsQueryType } from "@/types/graphql/partner.generated";

export type UnpaidContractPaymentRow =
  UnpaidContractPaymentsQueryType["waitPayment"]["nodes"][number];

/**
 * Счета, которые ждут денег (wait_payment и on_way), для карточки на
 * дашборде. Партнёрский фильтр принимает один статус, поэтому два поля
 * одним запросом. Запрос уходит только при праве read ContractPayment: тот
 * же гейт, что у пункта меню «Биллинг» (право есть только у
 * администратора организации).
 */
export function useUnpaidContractPayments(): {
  rows: UnpaidContractPaymentRow[];
  count: number;
  loading: boolean;
} {
  const ability = useAbility();
  const skip = !ability.can("read", "ContractPayment");

  const { data, loading } = useQuery<UnpaidContractPaymentsQueryType>(
    UnpaidContractPaymentsQuery,
    { skip, fetchPolicy: "cache-and-network" }
  );

  if (skip || !data) return { rows: [], count: 0, loading: !skip && loading };

  return {
    rows: [...data.waitPayment.nodes, ...data.onWay.nodes],
    count: data.waitPayment.count + data.onWay.count,
    loading: false,
  };
}
